import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';

import React from 'react';

class QuickBIView extends React.Component {
    constructor() {
        super();
        this.state = {
            sourceUrl: '',
            innerHeight: 6000
        };
    }

    async componentDidMount() {
        auth.appendLog(`QuickBI=${this.props.pageName}`);
        const url = await UIFetchService.get(`/api/v2/form/group_referral/aliyun/quick_bi/pages_url/${this.props.pageName}`);
        this.setState({ sourceUrl: url[0] });

        if (!this.props.fixedHeight) {
            window.onresize = () => {
                this.setState({innerHeight: document.body.clientHeight - 120});
            }
            window.onresize();
        }
    }

    componentWillUnmount() {
        if (!this.props.fixedHeight) {
            delete window.onresize;
        }
    }

    render() {
        if (this.state.sourceUrl === undefined) {
            return <p>你没有权限访问此页面。</p>;
        }
        return <iframe
            hidden={this.props.hidden}
            id="QuickBIView"
            title={this.props.pageName}
            width="100%"
            height={this.state.innerHeight}
            frameBorder={0}
            //scrolling="no"
            style={{ border: "0px" }}
            src={this.state.sourceUrl} />;
    }
}

export default QuickBIView;